import { createContext } from 'react';

export const PreviewContext = createContext<{
  preview: boolean
}>({
  preview: false,
});
